export const mapPreOnboardingPayload = (formData) => ({
  personalDetails: {
    id: formData.personalDetailsId || null,
    preOnboardingId: formData.preOnboardingId || null,

    genderId: formData.genderId || null,
    dateOfBirth: formData.dob || null,
    maritalStatusId: formData.maritalStatusId || null,

    cibilScore: Number(formData.cibilScore || 0),
    cibilScoreDate: formData.cibilScoreDate || null,

    isPersonWithDisability: formData.personWithDisability === "Yes",

    disabilityCertificateBoardName: formData.disabilityBoardName || "",

    disabilityCertificateReferenceNo: formData.disabilityReferenceNumber || "",

    disabilityCertificateIssueDate: formData.disabilityCertificateDate || null,
    disabilityCertificateUrl: formData.disabilityFile || "",
  },

  address: {
    id: formData.addressId || null,
    preOnboardingId: formData.preOnboardingId || null,

    correspondenceAddressLine1: formData.corrAddressLine1 || "",

    correspondenceAddressLine2: formData.corrAddressLine2 || "",

    correspondenceAddressLine3: formData.corrAddressLine3 || "",

    correspondenceCityId: formData.corrCityId || null,
    correspondenceCityName: formData.corrCity || "",

    correspondenceStateId: formData.corrStateId || null,

    correspondenceDistrictId: formData.corrDistrictId || null,

    correspondencePincode: formData.corrPincode || "",

    permanentAddressLine1: formData.permanentAddressLine1 || "",

    permanentAddressLine2: formData.permanentAddressLine2 || "",

    permanentAddressLine3: formData.permanentAddressLine3 || "",

    permanentCityId: formData.permCityId || null,
    permanentCityName: formData.permCity || "",

    permanentStateId: formData.permStateId || null,

    permanentDistrictId: formData.permDistrictId || null,

    permanentPincode: formData.permanentPincode || "",
  },

  domicileDetails: {
    id: formData.domicileDetailsId || null,
    preOnboardingId: formData.preOnboardingId || null,

    stateOfOriginId: formData.stateOfOriginId || null,

    religionId: formData.religionId || null,

    isMinority: formData.minority === "Yes",

   // cityId: formData.domicileCityId || null,
    cityOrTown: formData.domicileCity || "",

    stateId: formData.stateOfDomicileId || null,

    districtId: formData.domicileDistrictId || null,

    casteCategoryId: formData.casteCategoryId || null,

    casteCommunity: formData.casteCommunity || "",
    casteCertificateUrl: formData.communityFile || "",

    nationality: formData.nationality || "",

    bloodGroup: formData.bloodGroup || "",

    panNo: formData.panNo || "",
    panUrl: formData.panFileUrl || "",

    panApplied: !formData.panNo,

    panReferenceNo: formData.panReferenceNo || "",

    mobileNo: formData.mobile || "",

    emailAddress: formData.email || "",

    voterIdCardNo: formData.voterId || "",
    voterIdCardUrl: formData.voterIdFileUrl || "",

    drivingLicenseNo: formData.drivingLicenseNo || "",
    drivingLicenseUrl: formData.drivingLicenceFileUrl || "",

    passportNo: formData.passportNo || "",
    passportUrl: formData.passportFileUrl || "",

    // documents: [
    //   {
    //     documentType: "ADDRESS_PROOF",
    //     documentName: formData.addressProofFile?.name || "",

    //     documentUrl: formData.addressProofFileUrl || "",
    //   },
    // ],
    documents: [
      ...(formData.addressProofFileUrl
        ? [
            {
              documentType: "ADDRESS_PROOF",
              documentName: formData.addressProofFile?.name || "",
              documentUrl: formData.addressProofFileUrl || "",
            },
          ]
        : []),

      ...(formData.voterIdFileUrl
        ? [
            {
              documentType: "VOTER_ID",
              documentName: formData.voterIdFileName || "",
              documentUrl: formData.voterIdFileUrl || "",
            },
          ]
        : []),

      ...(formData.panFileUrl
        ? [
            {
              documentType: "PAN_CARD",
              documentName: formData.panFileName || "PAN_CARD",
              documentUrl: formData.panFileUrl || "",
            },
          ]
        : []),

      ...(formData.drivingLicenceFileUrl
        ? [
            {
              documentType: "DRIVING_LICENSE",
              documentName: formData.drivingLicenceFileName || "",
              documentUrl: formData.drivingLicenceFileUrl || "",
            },
          ]
        : []),

      ...(formData.passportFileUrl
        ? [
            {
              documentType: "PASSPORT",
              documentName: formData.passportFileName || "",
              documentUrl: formData.passportFileUrl || "",
            },
          ]
        : []),

      ...(formData.disabilityFile
        ? [
            {
              documentType: "DISABILITY_CERTIFICATE",
              documentName: formData.disabilityName || "",
              documentUrl: formData.disabilityFile || "",
            },
          ]
        : []),

      ...(formData.communityFile
        ? [
            {
              documentType: "CASTE_CERTIFICATE",
              documentName: formData.communityName || "",
              documentUrl: formData.communityFile || "",
            },
          ]
        : []),
    ],
  },

  disabilityDetails:
    formData.disabilities?.map((item) => ({
      id: item.id || null,

      preOnboardingId: formData.preOnboardingId || null,

      disabilityId: item.disabilityCategoryId || null,

      disabilityType: item.natureOfDisability || "",

      disabilityPercentage: Number(item.disabilityPercentage || 0),
    })) || [],

  // documents: [
  //   {
  //     documentType: "ADDRESS_PROOF",

  //     documentName: formData.addressProofFile?.name || "",

  //     documentUrl: formData.addressProofFileUrl || "",
  //   },
  // ],
  documents: [
    ...(formData.addressProofFileUrl
      ? [
          {
            documentType: "ADDRESS_PROOF",
            documentName: formData.addressProofFile?.name || "",
            documentUrl: formData.addressProofFileUrl || "",
          },
        ]
      : []),

    ...(formData.voterIdFileUrl
      ? [
          {
            documentType: "VOTER_ID",
            documentName: formData.voterIdFileName || "",
            documentUrl: formData.voterIdFileUrl || "",
          },
        ]
      : []),

    ...(formData.panFileUrl
      ? [
          {
            documentType: "PAN_CARD",
            documentName: formData.panFileName || "PAN_CARD",
            documentUrl: formData.panFileUrl || "",
          },
        ]
      : []),

    ...(formData.drivingLicenceFileUrl
      ? [
          {
            documentType: "DRIVING_LICENSE",
            documentName: formData.drivingLicenceFileName || "",
            documentUrl: formData.drivingLicenceFileUrl || "",
          },
        ]
      : []),

    ...(formData.passportFileUrl
      ? [
          {
            documentType: "PASSPORT",
            documentName: formData.passportFileName || "",
            documentUrl: formData.passportFileUrl || "",
          },
        ]
      : []),

    ...(formData.disabilityFile
      ? [
          {
            documentType: "DISABILITY_CERTIFICATE",
            documentName: formData.disabilityName || "",
            documentUrl: formData.disabilityFile || "",
          },
        ]
      : []),

    ...(formData.communityFile
      ? [
          {
            documentType: "CASTE_CERTIFICATE",
            documentName: formData.communityName || "",
            documentUrl: formData.communityFile || "",
          },
        ]
      : []),
  ],
});

export const mapPreviousOrganisationPayload = (
  formData,
  attestationDetails,
) => ({
  residentialHistory: attestationDetails.map((item) => ({
    id: item.id || null,
    preOnboardingId: item.preOnboardingId || null,

    fromDate: item.attestationFromDate || null,
    toDate: item.attestationToDate || null,

    addressLine1: item.addressLine1 || "",
    addressLine2: item.addressLine2 || "",
    addressLine3: item.addressLine3 || "",

    cityId: item.cityId || null,
    cityName: item.cityName || null,
    districtId: item.districtId || null,
    stateId: item.stateId || null,

    pincode: item.pinCode || "",

    docReferenceId:
      item.docReferenceId || null,
  })),

  previousOrganisations: formData.experienceDetails.map((item) => ({
    id: item.id || null,

    preOnboardingId: item.preOnboardingId || null,

    pranCardNumber: item.pranCardNumber || "",

    employeeCode: item.empCode || "",

    organisationName: item.organisationName || "",

    organisationAddress: item.organisationAddress || "",

    designation: item.designation || "",

    workDescription: item.descriptionOfWork || "",

    lastDrawnSalary: Number(item.lastDrawnSalary || 0),

    fromDate: item.fromDate || null,

    toDate: item.toDate || null,

    reasonForLeaving: item.reasonForLeaving || "",

    employerEmail: item.employerEmail || "",

    employerContactNo: item.employerContact || "",

    isCurrentlyWorking: item.isCurrentlyWorking,

    isCandidateRemoval: item.isCandidateRemove ?? false,

    // IMPORTANT: new API fields
    docReferenceId: item.preOnboardingDocumentId || null,
        documentName: item.experienceCertificateName || "",


    orgDocumentUrl: item.experienceCertificateUrl || "",
  })),
});